import React from 'react';
import { bool, shape, string } from 'prop-types';

const ApplicationType = ({
  className = 'icon',
  notUseClass = false,
  style = { color: 'currentColor' },
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.02832 16C7.27708 18.2499 9.18375 20 11.5 20C13.8162 20 15.7229 18.2499 15.9717 16H21V18H17.498C16.519 20.3486 14.2037 22 11.5 22C8.79632 22 6.48102 20.3486 5.50195 18H2V16H7.02832Z" fill="currentColor" />
    <path d="M9.7998 16.7002C9.89981 16.2002 10.4 15.9 11 16L12 16.2998C12.4998 16.4 12.8001 17.0001 12.7002 17.5C12.6002 17.9999 11.9999 18.3 11.5 18.2002L10.5 17.9004C10 17.8004 9.69986 17.2002 9.7998 16.7002Z" fill="currentColor" />
    <path d="M12.5996 13.2002C12.8996 12.7003 13.5001 12.4999 14 12.7998C14.4997 13.0998 14.6003 13.7003 14.4004 14.2002L13.9004 15.1006C13.6004 15.6004 12.9999 15.6998 12.5 15.5C12.0002 15.2001 11.8999 14.6005 12.0996 14.1006L12.5996 13.2002Z" fill="currentColor" />
    <path d="M8.40039 11.7998C8.80031 11.4003 9.39993 11.4002 9.7998 11.7998L10.5 12.5C10.8998 12.9 10.8998 13.5004 10.5 13.9004C10.1002 14.2999 9.5005 14.2997 9.10059 13.9004L8.40039 13.2002C8.00039 12.8002 8.00039 12.1998 8.40039 11.7998Z" fill="currentColor" />
    <path d="M14.252 4.6582L16.502 3.36035L19.002 7.69043L14.8848 9.85254C14.4501 10.0808 13.946 10.1414 13.4697 10.0225L9.25781 8.9707C8.72226 8.83666 8.39652 8.29343 8.53027 7.75781C8.66423 7.22215 9.20748 6.89554 9.74316 7.0293L11.6377 7.47559C12.0108 7.56898 12.4859 7.53544 12.5703 7.11719C12.6547 6.69894 12.3726 6.47768 11.9932 6.37598L9.03809 5.60352L3.45215 8.34178C2.95967 8.59092 2.30854 8.33577 2.08874 7.80128C1.87875 7.29066 2.05642 6.62551 2.54883 6.37598L8.47754 3.375L8.81934 3.20312L14.252 4.6582Z" fill="currentColor" />
    <path d="M22.0889 7.0625L20.3574 8.0625L16.8574 2L18.5889 1L22.0889 7.0625Z" fill="currentColor" />
  </svg>
);

ApplicationType.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default ApplicationType;
